<script>
export default
{
    name: 'mv-map',

    props:
    {
        value: null,
    },

    computed:
    {
        latLng()
        {
            return (this.value && this.value.length == 2) ? { lat: this.value[0], lng: this.value[1] } : { lat: 0, lng: 0 }
        }
    },

    methods:
    {
        setPlaceMarker(place)
        {
            if (place && place.latLng)
            {
                console.log(place)
                this.$emit('input', [
                    place.latLng.lat(),
                    place.latLng.lng()
                ])
            }

        },
    },

    data()
    {
        return {
            internalValue: this.value,
            mapOptions: {
                fullscreenControl: false,
                mapTypeControl: false,
                streetViewControl: false,
                scaleControl: false,
                rotateControl: false,
                panControl: false,
                zoomControl: false,
            }
        }
    },

}
</script>

<template>
<div>
    <gmap-map
        :center="latLng"
        :zoom="15"
        :options="mapOptions"
        style="width: 100%; height: 300px;"
    >
        <gmap-marker
            :position="latLng"
            clickable
            draggable
            @dragend="setPlaceMarker"
            ></gmap-marker>

    </gmap-map>
</div>
</template>


// WEBPACK FOOTER //
// src/components/Map.vue